import { useFeatureConfig } from "@hooks/useFeatureFlags";
import { type TFeatureConfigContextState } from "@/contexts/FeatureConfigContext/FeatureConfigContext";

type featureKey = keyof TFeatureConfigContextState;

interface IFeatureFlagProps {
  flag: featureKey | featureKey[];
  children?: React.ReactNode;
  renderOff?: React.ReactNode;
}

/**
 * Use boolean feature flags to conditionally render components.
 */
export const FeatureFlag: React.FC<IFeatureFlagProps> = (props) => {
  const { flag, children, renderOff } = props;
  const config = useFeatureConfig();

  if (typeof flag === "string") {
    return config[flag] ? children : renderOff;
  } else if (Array.isArray(flag)) {
    return flag.some((f) => config[f]) ? children : renderOff;
  }

  return null;
};
